// Centralized environment configuration
import { getEnv } from "./getEnv";

function bool(value, defaultValue = false) {
  if (value === undefined || value === null) return defaultValue;
  return String(value).toLowerCase() === "true";
}

export const env = {
  nodeEnv: getEnv("NODE_ENV") || "development",
  sfBaseUrl: getEnv("REACT_APP_SF_BASE_URL") || "",
  sfApexPrefix: getEnv("REACT_APP_SF_APEX_PREFIX") || "/services/apexrest",
  sfWithCredentials: bool(getEnv("REACT_APP_SF_WITH_CREDENTIALS"), false),
  sfProjectResource: getEnv("REACT_APP_SF_PROJECT_RESOURCE") || "/Project",
  sfPoResource: getEnv("REACT_APP_SF_PO_RESOURCE") || "/ProjectObjective",
  sfPpResource: getEnv("REACT_APP_SF_PP_RESOURCE") || "/ProjectPage",
  sfPpcResource: getEnv("REACT_APP_SF_PPC_RESOURCE") || "/ProjectPageComponent",
  sfPqsResource: getEnv("REACT_APP_SF_PQS_RESOURCE") || "/ProjectQualStep",
};

export const flags = {
  enableEsmDemo: bool(getEnv("REACT_APP_ENABLE_ESM_DEMO"), false),
  enableVitalsLog: bool(getEnv("REACT_APP_ENABLE_VITALS_LOG"), false),
};
